module.exports = __webpack_public_path__ + "media/patrimonio-animation-pt.6d820760.mp4";